import { AxiosInstance } from 'axios';
import { APIService } from '../../api';
import { Service } from '../../services/Service';
import { localStorage, Storage } from '../../storage';

export interface IpInfoType {
    city: string;
    country: string;
    hostname: string;
    ip: string;
    loc: string;
    org: string;
    postal: string;
    region: string;
    timezone: string;
}

export class IpInfo extends Service<IpInfo>() {
    public static STORE_KEY = 'IP_INFO_DATA';
    private readonly storage: Storage;
    private readonly endpoint: AxiosInstance;

    constructor() {
        super();

        this.storage = localStorage;
        this.endpoint = APIService.createHTTP('', {
            baseURL: 'https://ipinfo.io',
        });
    }

    private get apiKey() {
        return process.env.REACT_APP_IP_INFO_TOKEN || process.env.NEXT_PUBLIC_IP_INFO_TOKEN;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getCurrentInfo<T = IpInfoType>(): Promise<any> {
        const prevData = this.storage.getItem(IpInfo.STORE_KEY);
        if (prevData) {
            return prevData;
        }
        try {
            const { data } = await this.endpoint.get('', {
                headers: {
                    Authorization: `Bearer ${this.apiKey}`,
                },
            });
            this.storage.setItem(IpInfo.STORE_KEY, data);
            return data;
        } catch (e) {
            this.storage.setItem(IpInfo.STORE_KEY, { country: 'us' });
            return { country: 'us' };
        }
    }
}
